// Dirección del backend. En local es http://localhost:4000; en producción se define con VUE_APP_API_URL
// (ver Frontend/.env.production). Todos los servicios la toman de aquí.
export const API_ORIGIN = (process.env.VUE_APP_API_URL || 'http://localhost:4000').replace(/\/+$/, '')